
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenFullGoogle as ObiScreenFullGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-full-google.js';
 
 
 

 
 export const ObiScreenFullGoogle = createComponent({
   react: React,
   tagName: 'obi-screen-full-google',
   elementClass: ObiScreenFullGoogleElement,
   events: {
     
   }
  });
 
 